<!-- ------ Subscription ACTIVE -->
<div class="download-buttons-wrap" *ngIf="subscription && subscription.status && subscription.status.toLowerCase() === 'active'">
  <p>{{'SUBSCRIPTION.DOWNLOAD' | translate}}</p>
  <a [href]="storeLinks.HENTERPANT.appStore" class="store-btn apple" target="_blank"></a>
  <a [href]="storeLinks.HENTERPANT.googlePlay" class="store-btn android" target="_blank"></a>
</div>
<!-- ------ END Subscription ACTIVE -->

<!-- ------ User NOT Active -->
<div class="verification-wrap" *ngIf="!userData.active">
  <div class="alert-text">
    <i class="icon custom-alert-circle-filled"></i>
    <p>{{'SUBSCRIPTION.VERIFY' | translate}}</p>
  </div>
  <p class="text">{{'SUBSCRIPTION.CONFIRM' | translate}}</p>
  <button class="btn btn-secondary" (click)="openOtpModal()">{{'SUBSCRIPTION.VERIFICATION_BUTTON' | translate}}</button>
</div>
<!-- ------ END User NOT Active -->



<div class="wrap" *ngIf="subscriptionLoaded">

  <!-- ------ Subscription ACTIVE -->
  <div class="subscription-active-label" *ngIf="subscription && subscription.status && subscription.status.toLowerCase() === 'active'">
    <i class="icon custom-checkmark-traced"></i> {{'SUBSCRIPTION.ACTIVE' | translate}}
  </div>
  <!-- ------ END Subscription ACTIVE -->

  <div class="price-row">
    <div class="price">{{TOTAL}}{{'SUBSCRIPTION.CURRENCY' | translate}}<span>/{{'SUBSCRIPTION.MONTH' | translate}}</span></div>
    <div class="royalty"><span class="royalty-value">7%</span><span class="royalty-label">{{'SUBSCRIPTION.ROYALTY' | translate}}</span></div>
  </div>
  <small>{{'SUBSCRIPTION.INCLUDE_VAT' | translate}}</small>
  <h2 class="intro-price">{{'SUBSCRIPTION.INTRO_PRICE' | translate}}</h2>
  <h1>{{'SUBSCRIPTION.NAME' | translate}}</h1>
  <p class="description" [innerHTML]="'SUBSCRIPTION.DESCRIPTION' | translate"></p>

  <ul class="plan-list">
    <li><div class="icon-wrap"><i class="icon custom-checkmark-small"></i></div><p [innerHTML]="'SUBSCRIPTION.FEATURES.INCLUDED_ATHLETES' | translate"></p></li>
    <li><div class="icon-wrap"><i class="icon custom-checkmark-small"></i></div><p [innerHTML]="'SUBSCRIPTION.FEATURES.PARENT_TEAM_MANAGER' | translate"></p></li>
    <li><div class="icon-wrap"><i class="icon custom-checkmark-small"></i></div><p [innerHTML]="'SUBSCRIPTION.FEATURES.SHAREABLE_PROFILE' | translate"></p></li>
    <li><div class="icon-wrap"><i class="icon custom-checkmark-small"></i></div><p [innerHTML]="'SUBSCRIPTION.FEATURES.LIVE_STATISTICS' | translate"></p></li>
    <li><div class="icon-wrap"><i class="icon custom-checkmark-small"></i></div><p [innerHTML]="'SUBSCRIPTION.FEATURES.COACH_DASHBOARD' | translate"></p></li>
    <li><div class="icon-wrap"><i class="icon custom-checkmark-small"></i></div><p [innerHTML]="'SUBSCRIPTION.FEATURES.QUICK_START' | translate"></p></li>
  </ul>

  <!-- ------ Subscription NOT ACTIVE -->
  <div class="prices-info mt-5"   *ngIf="!subscription || !subscription.status || subscription.status.toLowerCase() !== 'active'">
    <div class="item">
      <p>{{'SUBSCRIPTION.AMOUNT' | translate}}</p>
      <p class="value">{{ amount }}{{'SUBSCRIPTION.CURRENCY' | translate}}</p>
    </div>
    <div class="item item-vat">
      <p>{{'SUBSCRIPTION.DISCOUNT' | translate}}</p>
      <p class="value">{{ discount }}{{'SUBSCRIPTION.CURRENCY' | translate}}</p>
    </div>
    <div class="item item-vat">
      <p>{{'SUBSCRIPTION.VAT' | translate}}</p>
      <p class="value">{{ vat }}{{'SUBSCRIPTION.CURRENCY' | translate}}</p>
    </div>
    <div class="item">
      <p>{{'SUBSCRIPTION.TOTAL' | translate}}</p>
      <p class="value">{{ total }}{{'SUBSCRIPTION.CURRENCY' | translate}}</p>
    </div>
  </div>
  <!-- ------ END Subscription NOT ACTIVE -->

  <div class="bank-logos">
    <a href="https://www.visa.no" target="_blank">
      <img ngSrc="../../../assets/images/logos/visa-secure.png" width="60" height="60" alt="Visa logo">
    </a>
    <a href="https://www.mastercard.no" target="_blank">
      <img ngSrc="../../../assets/images/logos/mc-logo.svg" class="mc" width="70" height="45" alt="MC logo">
    </a>
  </div>

  <!-- ------ Subscription NOT ACTIVE -->
  <div class="button-wrap mt-3" *ngIf="!subscription || !subscription.status || (subscription && subscription.status && subscription.status.toLowerCase() !== 'active')">
    <div class="form-check mb-3">
      <input type="checkbox" [(ngModel)]="termsAccepted" />
      <label>
        {{'SUBSCRIPTION.ACCEPT_1' | translate}} <a (click)="goToTermsConditions()" target="_blank">{{'SUBSCRIPTION.T&C' | translate}}</a>
        {{'SUBSCRIPTION.ACCEPT_2' | translate}} <a (click)="goToPrivacyPolicy()">{{'SUBSCRIPTION.P&P' | translate}}</a>
        <span>*</span>
      </label>
    </div>

    <button class="btn btn-primary-henterpant with-loader" type="button"
            (click)="runPaymentProcess()" [disabled]="!userData.active || !termsAccepted">
      {{'SUBSCRIPTION.BUTTON' | translate}} <span class="loader" *ngIf="loadingPaymentProcess"></span>
    </button>
    <small *ngIf="paymentProcessError" class="text-danger">
      {{'SUBSCRIPTION.ERROR' | translate}}
    </small>
    <div class="payment-info" aria-live="polite">
      <p class="title">{{ 'SUBSCRIPTION.PAYMENT_INFO_TITLE' | translate }}</p>
      <ul>
        <li *ngFor="let line of ('SUBSCRIPTION.PAYMENT_INFO_LINES' | translate)">{{ line }}</li>
      </ul>
    </div>
  </div>
  <!-- ------ END Subscription NOT ACTIVE -->
</div>


<!-- ------ Subscription ACTIVE -->
<div class="subscription-info" *ngIf="subscription && subscription.status && subscription.status.toLowerCase() === 'active'">
  <div class="item">
    <p>{{'SUBSCRIPTION.NEXT_PAYMENT' | translate}}</p>
    <p class="value">{{ subscription.expires_at | date: 'MMM d, YYYY' }}</p>
  </div>
  <div class="item">
    <p>{{'SUBSCRIPTION.AMOUNT' | translate}}</p>
    <p class="value">{{ amount }}{{'SUBSCRIPTION.CURRENCY' | translate}}</p>
  </div>
  <div class="item">
    <p>{{'SUBSCRIPTION.DISCOUNT' | translate}}</p>
    <p class="value">{{ discount }}{{'SUBSCRIPTION.CURRENCY' | translate}}</p>
  </div>
  <div class="item">
    <p>{{'SUBSCRIPTION.VAT' | translate}}</p>
    <p class="value">{{ vat }}{{'SUBSCRIPTION.CURRENCY' | translate}}</p>
  </div>
  <div class="item">
    <p>{{'SUBSCRIPTION.TOTAL' | translate}}</p>
    <p class="value">{{ total }}{{'SUBSCRIPTION.CURRENCY' | translate}}</p>
  </div>
</div>
<!-- ------ END Subscription ACTIVE -->

<ngx-smart-modal #otpModal identifier="otpModal" [customClass]="'otp-modal'" [closable]="false" [dismissable]="false"
                 (onOpen)="showOtp = true" (onClose)="showOtp = false">
  <div class="icon icon-close" (click)="closeOtp()"></div>
  <app-otp [phoneNumber]="userData.profile.phone_number" *ngIf="showOtp" [henterPantMode]="true"
           (getProject)="getProject()"></app-otp>
</ngx-smart-modal>
